<template>
  <div class="w-450">
    <inputComboBox2 placeholder="Document ..." v-model="searchInput">
      <template #dropd>
        <!-- If searchInput -->
        <!-- <div v-if="searchInput" class=""> -->
        <div>
          <!-- Favorites -->
          <template v-if="appUserStore.currentAppUserData?.preferences?.docAdministrative">
            <div class="mtop-05"/>
            <template v-for="(favorite, index) in appUserStore.currentAppUserData?.preferences?.docAdministrative.split('\n')" :key="index">
              <template v-if="favorite">
                <list-group @click="createAdminDocFromText(favorite)">
                  <text-item :txt="favorite" class="mleft-06 txt-primary"/>
                  <div class="mleft-03"></div>
                </list-group>
              </template>
            </template>
            <div class="line-h mtop-05" style="margin-bottom:0.5rem;"/>
          </template>
          <!-- All Documents -->
          <template v-for="(item, index) in filteredDocumentGroups" :key="index">
            <list-group @click="createAdminDocFromList(item.documentGroup)">
              <text-item :txt="item.tag.textTag" :styles="item.documentGroup.hasValidTemplates ? 'main-h' : 'main-l'" class="mleft-06"/>
              <!-- NOT IN V1
              <buttonGroup @click.stop style="margin-left: auto">
                <svg-item icon="settings" styles="main-l size-m"/>
              </buttonGroup>
              -->
              <div class="mleft-03"></div>
            </list-group>
          </template>
        </div>
        <!-- If empty -->
        <!-- <template v-else>
          <div class="pad-s">
            <text-item class="mleft-06" txt="Document ..." styles="main-m"/>
          </div>
        </template> -->


      </template>
    </inputComboBox2>
  </div>
</template>




<script setup>
import { useToast } from 'primevue';
import { ref, computed, onMounted } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { normalizeString } from "@/functions/medicReference"
import { useCurrentEntryStore } from '@/stores/currentEntry'
import patientapi from "@/api/patientapi"
import { toastError } from '@/utils/toast-utils';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const toast = useToast();
const currentEntryStore = useCurrentEntryStore()
const appUserStore = useAppUserStore()

const searchInput = ref("")
const documentGroups = ref([])

async function initialize() {
  documentGroups.value = createDocumentGroups(appUserStore.appUserDocumentGroups)
}

const currCclId = computed(() => {
  return currentEntryStore.currentCcl.conclusionGroupId.toString()
})

async function createAdminDoc(docGroup){
  const documentOriginalText = docGroup.mainDescription
  const tempDocId = docGroup.documentGroupId

  //Reload
  currentEntryStore.setMiddleTab('docTemplate')
  currentEntryStore.emptyCurrentDoc()
  const newDoc = await patientapi.addCustomTemplateToCcl(currCclId.value, tempDocId, documentOriginalText, currentEntryStore.currentEntryId)
  currentEntryStore.setCurrentDoc(newDoc)
  currentEntryStore.reloadCurrentEntry(currentEntryStore.currentEntryId)

}

function createAdminDocFromList(docGroup) {
  if (!docGroup.hasValidTemplates) return;
  createAdminDoc(docGroup);
}

async function createAdminDocFromText(documentOriginalText){
  if (!documentOriginalText) return;
  try {
    const documentGroup = await patientapi.getDocumentGroupByText(documentOriginalText);
    createAdminDoc(documentGroup);
  } catch (error) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t('error.PATIENT_DOCUMENT_GROUP_NOT_FOUND')
    });
    return;
  }
}

const normalizedSearchString = computed(() => {
  return normalizeString(searchInput.value)
})

const filteredDocumentGroups = computed(() => {
  const items = documentGroups.value
  const searchString = normalizedSearchString.value
  if (searchString.length <= 1) return items
  return items.filter(item => {
    return item.searchTerm.includes(searchString)
  })
})

// const filteredDocumentGroups = computed(() => {
//   let ret = []
//   const searchString = normalizedSearchString.value
//   if (searchString.length < 1) return ret
//   const searchParts = searchString.split(" ")
//   const firstPart = searchParts[0]
//   const otherParts = searchParts.slice(1)
//   const groups = documentGroups.value

//   if (searchParts.length === 1) {
//     const startsWithList = groups.filter(documentGroup => documentGroup.searchTerm.startsWith(firstPart))
//     //sortMedicRefList(startsWithList)
//     const includesList = []
//     groups.forEach(documentGroup => {
//       if (documentGroup.searchTerm.includes(firstPart) && !startsWithList.includes(documentGroup)) includesList.push(documentGroup);
//     })
//     //sortMedicRefList(includesList)
//     ret = [...startsWithList, ...includesList]    
//   } else if (searchParts.length > 1) {
//     ret = groups.filter(medic => 
//       medic.searchTerm.startsWith(firstPart) && otherParts.every(part => medic.searchTerm.includes(part))
//     )
//     //sortMedicRefList(ret)
//   }
//   return ret.slice(0, maxItems)
// })

// const cclRefSheets = computed(() => {
//   const resultExpressions = currentEntryStore.currCclSuggestionsFromResults?.expressions || []
//   const uniqueIds = new Set()
//   const uniqueRefSheetList = []
//   resultExpressions.forEach(({ refSheet }) => {
//     if (!refSheet) return
//     const id = refSheet.appUserResultReferenceId
//     if (!uniqueIds.has(id)) {
//       uniqueIds.add(id)
//       uniqueRefSheetList.push(refSheet)
//     }
//   })
//   return uniqueRefSheetList
// })


function createDocumentGroups(allDocumentGroups) {
  const arrangedList = allDocumentGroups.flatMap(documentGroup => {
    const tagArr = documentGroup.tags
    return tagArr.map(tag => ({
      documentGroup,
      tag,
      searchTerm: normalizeString(tag.textTag),
    }))
  })
  arrangedList.sort((a, b) => a.searchTerm.localeCompare(b.searchTerm))
  return arrangedList
}

onMounted(() => {
  initialize()
})

</script>

<style scoped>
</style>